import { useState } from 'react'
import type { Preset } from '../types'
import { importGammesBulk } from '../lib/api'

const PRESETS_KEY = 'microtonal_presets'

interface ImportLocalDataBannerProps {
  onDone: () => void
}

export const ImportLocalDataBanner = ({ onDone }: ImportLocalDataBannerProps) => {
  const [status, setStatus] = useState<'idle' | 'importing' | 'error'>('idle')
  const [result, setResult] = useState<{ imported: number; skipped: string[] } | null>(null)

  let localPresets: Preset[] = []
  try {
    const stored = localStorage.getItem(PRESETS_KEY)
    if (stored) localPresets = JSON.parse(stored)
  } catch {
    localPresets = []
  }

  if (localPresets.length === 0 || result) {
    if (result) {
      return (
        <div className="bg-emerald-50 border-b border-emerald-200 px-6 py-3 text-sm text-emerald-800 flex items-center justify-between">
          <span>
            ✅ {result.imported} gamme(s) importée(s) vers le serveur
            {result.skipped.length > 0 && ` (${result.skipped.length} déjà existante(s) ignorée(s))`}.
          </span>
          <button onClick={onDone} className="underline">
            Fermer
          </button>
        </div>
      )
    }
    return null
  }

  const handleImport = async () => {
    setStatus('importing')
    try {
      const res = await importGammesBulk(localPresets)
      localStorage.removeItem(PRESETS_KEY)
      localStorage.removeItem('microtonal-tuner-storage')
      setResult(res)
      setStatus('idle')
    } catch {
      setStatus('error')
    }
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-6 py-3 text-sm text-amber-900 flex items-center justify-between gap-4">
      <span>
        📦 {localPresets.length} gamme(s) trouvée(s) dans ce navigateur (ancien stockage local). Les
        importer vers le serveur ?
      </span>
      <div className="flex items-center gap-2 shrink-0">
        {status === 'error' && <span className="text-red-600">Erreur, réessayez.</span>}
        <button
          onClick={handleImport}
          disabled={status === 'importing'}
          className="px-4 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-medium disabled:opacity-50"
        >
          {status === 'importing' ? 'Import...' : 'Importer'}
        </button>
        <button onClick={onDone} className="underline text-amber-700">
          Ignorer
        </button>
      </div>
    </div>
  )
}
